export default __webpack_public_path__ + "static/media/Armbands of the Cloudcleaver.86392029.jpg";